import { Component, OnInit, Input } from '@angular/core';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-giftcard-list-element',
  templateUrl: './giftcard-list-element.component.html',
  styleUrls: ['./giftcard-list-element.component.css']
})
export class GiftCardListElementComponent implements OnInit {

  @Input()
  title: string;

  @Input()
  price: string;

  constructor() { }

  ngOnInit() {
  }

  local_currency() {
    return environment.globalSettings.local_currency;
  }
}
